import { render, staticRenderFns } from "./liveIndex.vue?vue&type=template&id=67c54cbc&"
import script from "./liveIndex.vue?vue&type=script&lang=js&"
export * from "./liveIndex.vue?vue&type=script&lang=js&"
import style0 from "./liveIndex.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "liveIndex.vue"
export default component.exports